import { Record } from "immutable";
import { DateStringNumber, Nullable } from "common/records";
import { checkDate } from "common/helpers/Date";

export const jobStateLogFromJSON = (json: Partial<IJobStateLogData>): JobStateLogRecord => {
  const data: IJobStateLogRecord = { ...(json as any as IJobStateLogRecord) };

  if (json.created_at) {
    data.created_at = checkDate(json.created_at);
  }

  return new JobStateLogRecord(data);
};

export interface IJobStateLogData {
  id: number;
  job_id: number;
  from: string;
  to: string;
  event: string;
  user: string;

  created_at: DateStringNumber;
}

export interface IJobStateLogRecord {
  id: number;
  job_id: number;
  from: string;
  to: string;
  event: string;
  user: string;

  created_at: Nullable<DateStringNumber>;
}

export const defaultJobStateLogProps = {
  id: 0,
  job_id: 0,
  from: "",
  to: "",
  event: "",
  user: "",

  created_at: null,
};

export class JobStateLogRecord
  extends Record<IJobStateLogRecord>(defaultJobStateLogProps)
  implements IJobStateLogRecord {}
